import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Platform, Canvas } from '@brandwatch/axiom-components';

import InfoConsole from '../containers/InfoConsole/InfoConsole';
import loadTheme from '../loadTheme';

import {deviceType} from '../DeviceTypeContext.jsx';

import './ViziaPlatform.css';

const ViziaPlatform = ({
  setUiMode,
  isConsoleOpen,
  isScrollLocked,
  toggleInfoConsole,
  showDialogBackground,
  options = {},
  children
}) => {
  const {theme, themeId} = options;

  useEffect(() => {
    setUiMode({
      mode: deviceType.isMobile ? 'scroll' : 'slideshow'
    });
  }, [setUiMode]);

  useEffect(() => {
    if (isScrollLocked) {
      document.documentElement.style['overflow-y'] = 'hidden';
      document.documentElement.style['touch-action'] = 'none';
    } else {
      document.documentElement.style['overflow-y'] = null;
      document.documentElement.style['touch-action'] = null;
    }
  }, [isScrollLocked]);

  useEffect(() => {
    if (theme || themeId) {
      loadTheme({theme, themeId});
    }
  }, [theme, themeId]);

  return (
    <div className={classNames('App', {
      'App--error': showDialogBackground
    })}>
      <Platform
        openConsolePosition={isConsoleOpen ? 'right' : null}
        openConsoleWidth="0"
        onConsoleClose={toggleInfoConsole}
        theme="night"
      >
        <InfoConsole />
        <Canvas>
          <div className="App__body">
            {children}
          </div>
        </Canvas>
      </Platform>
    </div>
  );
};

ViziaPlatform.propTypes = {
  children: PropTypes.node,
  options: PropTypes.object,
  isConsoleOpen: PropTypes.bool.isRequired,
  isScrollLocked: PropTypes.bool.isRequired,
  setUiMode: PropTypes.func.isRequired,
  toggleInfoConsole: PropTypes.func.isRequired,
  showDialogBackground: PropTypes.bool.isRequired,
};

export default ViziaPlatform;
